import React from "react";
import Popup from "./Popup";

const ChatSelectPopup = ({ name, title }) => (
    <Popup name={name} className="popup-chat-select">
        <div className="popup-chat-select__content">
            <div className="popup-chat-select__name">{title}</div>
        </div>
        <div className="popup-chat-select__content">
            <a href="https://t.me/+79148803294" target="_blank" aria-label="Telegram" >
                <div className="popup-chat-select__icon popup-chat-select__icon-telegram"></div>
                <p>Telegram</p>
            </a>
            <a href="https://wa.me/79148803294" target="_blank" aria-label="WhatsApp">
                <div className="popup-chat-select__icon popup-chat-select__icon-whatsapp"></div>
                <p>WhatsApp</p>
            </a>
        </div>
    </Popup>
);

export default ChatSelectPopup;
